import { FEATURE_SETS } from "@/services/featureSet.js"

export default [
  {
    path: "/settings",
    name: "SettingsOverview",
    component: () => import("@/views/settings/SettingsOverview"),
    meta: { title: "nav.settings", requiresAuth: true },
  },
  // The PDF-Vorlagen' two editors: a page each, because a Briefpapier is designed on an A4 canvas and a
  // Vorlage beside its preview, neither of which fits a dialog. Opened from the settings tab; a paid
  // add-on, so both carry `requiresFeatureSet` like the backend's controllers.
  {
    path: "/settings/pdf/letterhead/:letterheadId",
    name: "PdfLetterheadEditor",
    component: () => import("@/views/settings/pdf/PdfLetterheadEditor.vue"),
    props: true,
    meta: {
      title: "settings.pdf.letterhead_editor.title",
      requiresAuth: true,
      requiresFeatureSet: FEATURE_SETS.DOCUMENT_DESIGN,
    },
  },
  {
    path: "/settings/pdf/template/:templateId",
    name: "PdfTemplateEditor",
    component: () => import("@/views/settings/pdf/PdfTemplateEditor.vue"),
    props: true,
    meta: {
      title: "settings.pdf.template_editor.title",
      requiresAuth: true,
      requiresFeatureSet: FEATURE_SETS.DOCUMENT_DESIGN,
    },
  },
]
